import {
	NOTIFICATION_CREATE,
	NOTIFICATION_CREATE_SUCCESS,
	NOTIFICATION_CREATE_ERROR,
	NOTIFICATIONS_LIST_FILTERED,
	NOTIFICATIONS_LIST_FILTERED_SUCCESS,
	NOTIFICATIONS_LIST_FILTERED_ERROR,
	NOTIFICATION_SET_VIEWED,
	NOTIFICATION_SET_VIEWED_SUCCESS,
	NOTIFICATION_SET_VIEWED_ERROR,
} from "../actions/notifications";
import NotificationsService from '@/services/notifications';

const state = {
	status: ''
};

const getters = {
};

const actions = {
	[NOTIFICATION_CREATE]: ({ commit, dispatch }, data) => {
		let requestData = {
			id: data.id,
			title: data.title,
			content: data.content,
		}
		return new Promise((resolve, reject) => {
			commit(NOTIFICATION_CREATE);
			NotificationsService.create(requestData)
				.then(data => {
					commit(NOTIFICATION_CREATE_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(NOTIFICATION_CREATE_ERROR, error);
					reject(error);
				});
		});
	},
	[NOTIFICATIONS_LIST_FILTERED]: ({ commit }, data) => {
		let requestData = {
			size: data.props.itemsPerPage,
			page: data.props.currentPage,
		}
		return new Promise((resolve, reject) => {
			commit(NOTIFICATIONS_LIST_FILTERED);
			NotificationsService.listFiltered(requestData)
				.then(responseData => {
					commit(NOTIFICATIONS_LIST_FILTERED_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(NOTIFICATIONS_LIST_FILTERED_ERROR, error);
					reject(error);
				});
		});
	},
	[NOTIFICATION_SET_VIEWED]: ({ commit, dispatch }, notification_id) => {
		let requestData = {
			id: notification_id,
		}
		return new Promise((resolve, reject) => {
			commit(NOTIFICATION_SET_VIEWED);
			NotificationsService.setViewed(requestData)
				.then(data => {
					commit(NOTIFICATION_SET_VIEWED_SUCCESS);
					resolve(data);
				})
				.catch(error => {
					commit(NOTIFICATION_SET_VIEWED_ERROR, error);
					reject(error);
				});
		});
	},
};

const mutations = {
	[NOTIFICATION_CREATE]: state => {
		state.status = 'loading';
	},
	[NOTIFICATION_CREATE_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[NOTIFICATION_CREATE_ERROR]: state => {
		state.status = 'error';
	},
	[NOTIFICATIONS_LIST_FILTERED]: state => {
		state.status = 'loading';
	},
	[NOTIFICATIONS_LIST_FILTERED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[NOTIFICATIONS_LIST_FILTERED_ERROR]: state => {
		state.status = 'error';
	},
	[NOTIFICATION_SET_VIEWED]: state => {
		state.status = 'loading';
	},
	[NOTIFICATION_SET_VIEWED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[NOTIFICATION_SET_VIEWED_ERROR]: state => {
		state.status = 'error';
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};